import "./App.css";
import "./index.css";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import AirlineLogin from "./Pages/AirlineLogin";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import ManageUsers from "./Pages/Customer/ManageUsers";
import User from "./Pages/Customer/User";
import myImage from "../src/assets/deskbaord-main-bg.svg";
import { getCustomerUserPermissions } from "./redux/actions/CustomerAction";
// import TicketReport from "./Pages/Customer/TicketReport";
import NewTicketReport from "./Pages/Customer/NewTicketReport";
import MultiPccTicketReport from "./Pages/Customer/MultiPccTicketReport";
import ManageMyItinerary from "./Pages/Customer/ManageMyItinerary";
import DisplayItinerary from "./Pages/Customer/DisplayItinerary";
import CustomerLogs from "./Pages/Customer/CustomerLogs";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = JSON.parse(localStorage.getItem("userInfo"));
  // const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const cust_user_id = JSON.parse(localStorage.getItem("customer_user_id"));
  const location = useLocation();

  const [decodedToken, setDecodedToken] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);
  const [checkUserPermission, setCheckUserPermission] = useState(
    () => () => false
  ); // Default to a no-op function

  const GetCustomerUserPermissions = useSelector(
    (state) => state.GetCustomerUserPermissions
  );
  const { customerUserPermissionsInfo } = GetCustomerUserPermissions;

  const hasAccess = (allowedRoles) => allowedRoles.includes(loggedInUserRole);

  // // Track user's current route and save it in localStorage
  // useEffect(() => {
  //   if (location.pathname !== "/login" && location.pathname !== "/") {
  //     localStorage.setItem("lastVisitedPath", location.pathname);
  //   }
  // }, [location.pathname]);

  // // On initial load, check if there is a last visited path and navigate to it
  // useEffect(() => {
  //   const lastVisitedPath = localStorage.getItem("lastVisitedPath");
  //   console.log("lastVisitedPath"+lastVisitedPath)
  //   if (token && lastVisitedPath !== "/changepassword") {
  //     navigate(lastVisitedPath, { replace: true });
  //   }
  //   if (!lastVisitedPath) {
  //     navigate("/dashboard", { replace: true });
  //   }
  // }, [token, navigate]);

  // get customer user permission
  useEffect(() => {
    if (loggedInUserRole === "customer_user") {
      dispatch(getCustomerUserPermissions(cust_user_id));
    }
  }, [loggedInUserRole, cust_user_id]);

  useEffect(() => {
    setCheckUserPermission(() => (productId, permission) => {
      if (loggedInUserRole === "customer") {
        return true;
      }
      if (loggedInUserRole === "customer_user") {
        const productPermissions = customerUserPermissionsInfo?.find(
          (p) => p.product_id === productId
        );
        return productPermissions ? productPermissions[permission] : false;
      }
    });
  }, [loggedInUserRole, customerUserPermissionsInfo]);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const locator = searchParams.get("locator");
      const pcc = searchParams.get("pcc");

      if (locator) sessionStorage.setItem("pnr", locator);
      if (pcc) sessionStorage.setItem("pcc", pcc);

      if (location.pathname === "/dashboard/products/managemyitineraryresult") {
        // setCheckUserPermission(() => () => true);
        navigate("/dashboard/products/managemyitineraryresult", {
          replace: true,
        });
      }
    }
  }, [location.search, location.pathname, navigate]);

  useEffect(() => {
    if (location.pathname === "/dashboard/products/managemyitinerary") {
      dispatch({ type: "GET_MANAGE_BOOKING_DATA_RESET" });
      dispatch({ type: "CHECK_LOGGED_IN_USER_PCC_RESET" });
    }
  }, [location.pathname, dispatch]);

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const role = decodedToken.role;
        setLoggedInUserRole(role);
        setDecodedToken(decodedToken);
      } catch (error) {
        console.error("Invalid token or error decoding:", error);
        navigate("/");
      }
    }
    const checkTokenExpiration = () => {
      const tokenExpiration = localStorage.getItem("tokenExpiration");
      if (tokenExpiration && new Date(tokenExpiration) < new Date()) {
        // Token has expired
        localStorage.removeItem("userInfo");
        localStorage.removeItem("customer_email");
        localStorage.removeItem("tokenExpiration");
        localStorage.removeItem("customer_id");
        localStorage.removeItem("customer_login_id");
        localStorage.removeItem("customer_user_id");
        localStorage.removeItem("customer_user_username");
        sessionStorage.removeItem("pnr");
        sessionStorage.removeItem("pcc");
        navigate("/", { state: { from: location } });
      }
    };

    checkTokenExpiration();

    const interval = setInterval(checkTokenExpiration, 60000); // Check every minute

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [token, navigate]);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            !token ? (
              <Login page="login" />
            ) : (
              <Navigate to={location.state?.from?.pathname || "/dashboard"} />
            )
          }
        />
          <Route
          path="/airlineLogin"
          element={
            !token ? (
              <AirlineLogin page="airlineLogin" />
            ) : (
              <Navigate to={location.state?.from?.pathname || "/dashboard"} />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            token ? (
              <Home
                decodedToken={decodedToken}
                checkUserPermission={checkUserPermission}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        >
          <Route
            index
            element={
              <div className="content-page">
                <img src={myImage} alt="Description" />
              </div>
            }
          />

          {/* USER Section */}
          <Route
            path="users/manageusers"
            element={
              token && hasAccess(["customer"]) ? (
                <ManageUsers decodedToken={decodedToken} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="users/add-new-user/:id"
            element={
              token && hasAccess(["customer"]) ? (
                <User decodedToken={decodedToken} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Product Section */}

          {/* <Route
            path="products/ticketreport"
            element={
              token && hasAccess(["customer", "customer_user"]) ? (
                <TicketReport
                  decodedToken={decodedToken}
                  checkUserPermission={checkUserPermission}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          /> */}

          <Route
            path="products/ticketreport"
            element={
              token && hasAccess(["customer", "customer_user"]) ? (
                <NewTicketReport
                  decodedToken={decodedToken}
                  checkUserPermission={checkUserPermission}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="products/multipccticketreport"
            element={
              token && hasAccess(["customer", "customer_user"]) ? (
                <MultiPccTicketReport
                  decodedToken={decodedToken}
                  checkUserPermission={checkUserPermission}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="products/managemyitinerary"
            element={
              token && hasAccess(["customer", "customer_user"]) ? (
                <ManageMyItinerary decodedToken={decodedToken} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="products/managemyitineraryresult"
            element={
              token && hasAccess(["customer", "customer_user"]) ? (
                <DisplayItinerary decodedToken={decodedToken} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Logs */}

          <Route
            path="logs/viewuserlogs"
            element={
              token && hasAccess(["customer"]) ? (
                <CustomerLogs decodedToken={decodedToken} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
